"use client";

import { useEffect } from "react";
import { shouldResetDocumentScroll } from "@/lib/documentScroll";

export default function DocumentScrollReset() {
    useEffect(() => {
        const resetDocumentScroll = () => {
            if (!shouldResetDocumentScroll(window.scrollX, window.scrollY, document.activeElement)) return;
            window.scrollTo(0, 0);
        };
        const resetAfterFocusLeaves = () => {
            window.setTimeout(resetDocumentScroll, 100);
        };

        window.addEventListener("scroll", resetDocumentScroll, { passive: true });
        window.addEventListener("focusout", resetAfterFocusLeaves);
        window.visualViewport?.addEventListener("resize", resetDocumentScroll);

        return () => {
            window.removeEventListener("scroll", resetDocumentScroll);
            window.removeEventListener("focusout", resetAfterFocusLeaves);
            window.visualViewport?.removeEventListener("resize", resetDocumentScroll);
        };
    }, []);

    return null;
}
